module.exports = __webpack_public_path__ + "static/media/whatsapp.8671d88f.svg";